import { Module } from "vuex";
import { State } from "@/store/modules/country/state";
import Mutations from "@/store/modules/country/mutations";
import Getters from "@/store/modules/country/getters";
import Actions from "@/store/modules/country/actions";

export class Country implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
